import {INTERNAL_COLUMN_PREFIX, SYSTEM_COLUMN_PREFIX} from 'data-frames/DataFrameConstants';
import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';

// Returns true for columns that are not user-facing: the deprecated `benchcol_` system columns and
// the internal `bnch__` library-generated columns (e.g. `bnch__row_id`). Both are hidden from the
// data frame viewer, column pickers, and user-column computations.
export default function isSystemColumn(column: DataFrameColumnDef): boolean {
  return (
    column.systemName.startsWith(SYSTEM_COLUMN_PREFIX) || column.systemName.startsWith(INTERNAL_COLUMN_PREFIX)
  );
}
